export default __webpack_public_path__ + "static/media/information--water-protection-zone--g1.44b0f53a.png";